import useHeaderEventsCore from '@travel/traveler-core/hooks/useHeaderEvents';

import { logout } from 'promotions/store/authCode/actions';

const useHeaderEvents = () => {
  useHeaderEventsCore({ logout });
};

export default useHeaderEvents;
